import axios from '@/api/config';

const department = {
  getDepartmentFirst(data) {
    return axios.get(`${process.env.BASE_URL}/department/getDepartmentFirst`, { params: data });
  },
  getDepartmentListByTreeId(data) {
    return axios.get(`${process.env.BASE_URL}/department/getDepartmentListByTreeId`, { params: data });
  },
  getDepartment(data) {
    return axios.get(`${process.env.BASE_URL}/department/getDepartment`, { params: data });
  },
  getNewDepartmentTreeList(data) {
    return axios.get(`${process.env.BASE_URL}/department/getNewDepartmentTreeList`, { params: data });
  },
  getDepartmentList(data) {
    return axios.get(`${process.env.BASE_URL}/department/getDepartmentList`, { params: data });
  },
  getDepartmentTree(data) {
    return axios.get(`${process.env.BASE_URL}/department/getDepartmentTree`, { params: data });
  },
  departmentTreeList(data) {
    return axios.get(`${process.env.BASE_URL}/department/departmentTreeList`, { params: data });
  },
  departmentTreeList(data) {
    return axios.get(`${process.env.BASE_URL}/department/departmentTreeList`, { params: data });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/department/pageList`, data);
  },
  tableList(data) {
    return axios.get(`${process.env.BASE_URL}/department/tableList`, data);
  },
  addDepartment(data) {
    return axios.post(`${process.env.BASE_URL}/department/addDepartment`, data);
  },
  deleteDepartment(data) {
    return axios.delete(`${process.env.BASE_URL}/department/deleteDepartment`, { data: data });
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/department/exportExcel`, { params: data });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/department/importData`, data);
  },
  updateDepartment(data) {
    return axios.post(`${process.env.BASE_URL}/department/updateDepartment`, data);
  }
}

export default department;



// WEBPACK FOOTER //
// ./src/api/department.js